import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";

// const ClientsLogoSection = lazy(() => import("./ClientsLogoSection"));
// const Testimonial = lazy(() => import("./Testimonial"));
const FeaturedCaseStudySection = lazy(() => import("./FeaturedCaseStudySection"));
const ImpactMetricsSection = lazy(() => import("./ImpactMetricsSection"));
// const ReviewSection = lazy(() => import("./ReviewSection"));

const Clients = () => {
  return (
    <>
     <Helmet>
  <title>
    Clients & Case Studies | Winglo Success Stories
  </title>

  <meta
    name="description"
    content="Explore Winglo client success stories across Healthcare and Education. Discover how our cloud-based solutions have transformed institutions with measurable impact."
  />

  <meta
    name="keywords"
    content="Winglo clients, case studies, healthcare LIMS success story, education ERP implementation, digital transformation case study"
  />
</Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" aria-busy="true" />}>
      {/* <ClientsLogoSection /> */}
      <FeaturedCaseStudySection />
      <ImpactMetricsSection />
       {/* <Testimonial /> */}
       {/* <ReviewSection /> */}
      </Suspense>
    </>
  );
};

export default Clients;
